var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 470 470",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:url(#linear-gradient);stroke-width:14px;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2{fill:url(#linear-gradient-4);stroke:url(#linear-gradient-5);}.cls-2,.cls-3{stroke-width:4px;}.cls-3{fill:url(#linear-gradient-2);stroke:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 235,
    x2: 470,
    y2: 235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bb4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2191e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007edb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 80,
    y1: 132.99,
    x2: 390,
    y2: 132.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 78,
    y1: 132.99,
    x2: 392,
    y2: 132.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 80,
    y1: 337.01,
    x2: 390,
    y2: 337.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 78,
    y1: 337.01,
    x2: 392,
    y2: 337.01,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 7,
    width: 456,
    height: 456,
    rx: 88.32,
    ry: 88.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m95.8,216.04h278.4c8.72,0,15.8-7.07,15.8-15.8s-7.07-15.8-15.8-15.8h-123.4l64.55-64.73c6.23-6.11,6.34-16.11.23-22.34-3.01-3.07-7.13-4.78-11.42-4.74-4.2-.02-8.23,1.64-11.19,4.6l-42.16,42.25v-73.75c0-8.72-7.07-15.8-15.8-15.8s-15.8,7.07-15.8,15.8v73.84l-42.16-42.25c-6.27-5.96-16.12-5.96-22.39,0-6.15,6.2-6.15,16.19,0,22.39l64.55,64.46h-123.4c-8.72,0-15.8,7.07-15.8,15.8s7.07,15.8,15.8,15.8v.27Zm0-22.57h127.92c2.49,0,4.51-2.02,4.51-4.51v-6.59c.02-1.22-.47-2.4-1.35-3.25l-65.81-65.81c-2.64-2.64-2.64-6.93,0-9.57,2.68-2.54,6.89-2.54,9.57,0l49.92,50.01c1.29,1.26,3.2,1.64,4.87.99,1.72-.7,2.83-2.39,2.8-4.24v-84.77c0-3.74,3.04-6.77,6.78-6.76,3.73,0,6.75,3.03,6.76,6.76v84.68c-.03,1.86,1.08,3.54,2.8,4.24,1.66.67,3.56.32,4.87-.9l49.92-49.92c2.74-2.55,7.02-2.4,9.57.34,2.42,2.6,2.42,6.63,0,9.23l-65.81,65.72c-.88.85-1.37,2.03-1.35,3.25v6.59c0,2.49,2.02,4.51,4.51,4.51h127.92c3.74,0,6.77,3.03,6.77,6.77s-3.03,6.77-6.77,6.77H95.8c-3.74,0-6.77-3.03-6.77-6.77s3.03-6.77,6.77-6.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m374.2,253.96H95.8c-8.72,0-15.8,7.07-15.8,15.8s7.07,15.8,15.8,15.8h123.4l-64.55,64.73c-6.15,6.2-6.15,16.19,0,22.39,6.27,5.96,16.12,5.96,22.39,0l42.16-42.25v73.84c0,8.72,7.07,15.8,15.8,15.8s15.8-7.07,15.8-15.8h0v-73.84l42.16,42.25c2.97,2.97,7,4.63,11.19,4.6,4.2.02,8.23-1.64,11.19-4.6,6.15-6.2,6.15-16.19,0-22.39l-64.55-64.46h123.4c8.72,0,15.8-7.07,15.8-15.8s-7.07-15.8-15.8-15.8v-.27Zm0,22.57h-127.92c-2.49,0-4.51,2.02-4.51,4.51v6.59c-.02,1.22.47,2.4,1.35,3.25l65.81,65.81c2.74,2.55,2.89,6.83.34,9.57-2.55,2.74-6.83,2.89-9.57.34-.12-.11-.23-.22-.34-.34l-49.92-50.01c-1.29-1.26-3.2-1.64-4.87-.99-1.72.7-2.83,2.39-2.8,4.24v84.68c0,3.74-3.03,6.77-6.77,6.77s-6.77-3.03-6.77-6.77v-84.59c.03-1.86-1.08-3.54-2.8-4.24-.57-.09-1.15-.09-1.72,0-1.18,0-2.31.45-3.16,1.26l-49.92,49.92c-2.68,2.54-6.89,2.54-9.57,0-2.64-2.64-2.64-6.93,0-9.57l65.81-65.81c.88-.85,1.37-2.03,1.35-3.25v-6.86c0-2.49-2.02-4.51-4.51-4.51h-127.92c-3.74,0-6.77-3.03-6.77-6.77s3.03-6.77,6.77-6.77h278.4c3.74,0,6.77,3.03,6.77,6.77s-3.03,6.77-6.77,6.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseArrows);
export default __webpack_public_path__ + "static/media/collapse-arrows.414182994c60e89a79d1887d6167bc70.svg";
export { ForwardRef as ReactComponent };